import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: '¿Cuánto tiempo toma importar un vehículo?',
  answer: 'Normalmente el proceso completo suele tomar entre 4 a 6 semanas desde la compra en subasta hasta la entrega en El Salvador. Esto incluye transporte terrestre en USA, espera en puerto, tránsito marítimo y trámites aduanales.'
}, {
  question: '¿Qué tipos de vehículos puedo importar?',
  answer: 'Puedes importar vehículos livianos, camionetas, pick-ups y camiones. La ley permite importar vehículos de hasta 8 años de antigüedad para uso particular, aunque existen excepciones para vehículos de trabajo o clásicos.'
}, {
  question: '¿Incluyen el seguro de transporte?',
  answer: 'Sí, todos nuestros envíos incluyen un seguro de carga marítima que cubre pérdida total o daños catastróficos durante el trayecto en barco.'
}, {
  question: '¿Puedo rastrear mi vehículo?',
  answer: 'Sí, proporciono un sistema de seguimiento donde podrás ver el estado de tu vehículo en tiempo real: desde que sale de la subasta, llega al puerto, zarpa el barco y arriba a Acajutla.'
}, {
  question: '¿Qué pasa si el vehículo llega dañado?',
  answer: 'Realizamos inspecciones fotográficas en cada punto de transferencia (recogida, almacén, puerto). Si ocurre un daño durante nuestra custodia que no estaba presente en la subasta, nuestro seguro se hace cargo.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="py-20 bg-earia-bg-alt border-t border-earia-border" data-id="element-145">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-146">
        <div className="text-center mb-12" data-id="element-147">
          <h2 className="text-3xl md:text-4xl font-bold text-earia-text-heading mb-4" data-id="element-148">
            Preguntas frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-149">
          {faqs.map((faq, index) => <div key={index} className="bg-earia-card border border-earia-border rounded-lg overflow-hidden shadow-sm" data-id="element-150">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-4 flex items-center justify-between text-left focus:outline-none hover:bg-earia-bg transition-colors" data-id="element-151">
                <span className="text-earia-text-heading font-medium" data-id="element-152">
                  {faq.question}
                </span>
                <ChevronDown className={`w-5 h-5 text-earia-accent-hover transition-transform duration-200 ${openIndex === index ? 'transform rotate-180' : ''}`} data-id="element-153" />
              </button>

              <AnimatePresence data-id="element-154">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.2
            }} data-id="element-155">
                    <div className="px-6 pb-4 text-earia-text-body text-sm leading-relaxed border-t border-earia-border pt-4" data-id="element-156">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}